export const iconFontAwesomeSecurityFingerprint = (
	<i className="fa-solid fa-fingerprint"></i>
);
